import ReactHtmlParser from 'react-html-parser';
import anchorTransform from './transforms/anchor';

const htmlParserTransform = (node, events) =>
  anchorTransform(node, events?.onAnchorClick);

const HtmlParser = ({ children, onAnchorClick }) =>
  ReactHtmlParser(children, {
    transform: node =>
      htmlParserTransform(node, {
        onAnchorClick,
      }),
  });

export default HtmlParser;
